import React from 'react';
import './input_text.css';

const InputText = ({ label, id, name, value, onChange, placeholder, required = false, error, type = 'text', dataSection, className = '', disabled = false }) => {
    return (
        <div className={`base-input-container ${className}`}>
            <label className="base-label" htmlFor={id}>{label}</label>
            <input
                type={type}
                id={id}
                name={name}
                data-section={dataSection}
                value={value}
                onChange={onChange}
                required={required}
                placeholder={placeholder}
                disabled={disabled}
                className={`base-input-field ${error ? 'base-input-error' : ''}`}
            />
            {error && <span className="base-error-message">{error}</span>}
        </div>
    );
};

export default InputText;
